<template>
    <StoryTab
        v-if="tab == 'story'"
        :mode="mode"
        @changeTab="changeTab"
    />
    <StandardTab 
        v-else
        :mode="mode"
        @changeTab="changeTab"
    />
   

   
</template>

<script>

import StandardTab from '../postCreator/StandardTab.vue';
import StoryTab from '../postCreator/StoryTab.vue';
export default {
    components: {
        StandardTab,
        StoryTab
    },
 

    props: {
        mode: String,
        tab: {
            type : String,
            default : 'standard'
        },
    },

    data() {
        return {}
    },


    mounted() {       
    },

    methods: {
        changeTab(tabName) {
            if (!['standard', 'story'].includes(tabName)) return
            this.tab = tabName
        }
    },

    computed: {
   
    },

    
    watch: {
    },

    beforeDestroy () {
    }

}
</script>
